import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { QIDropdown } from "../QIDropdown";
import { SvgIcon } from "../../containers/Shared";

// QINotification: small wrapper that shows a bell icon with an unread
// notification count and renders the notification dropdown content.
// - `OnNotification` is a component passed in that receives notification props
// - `initialValue` provides the initial notification count (e.g. from server)
export const QINotification = ({ OnNotification, initialValue }) => {
  // Read websocket object from redux store (used to receive live messages)
  const ws = useSelector((state) => state.common.ws);

  // Local UI state
  const [dropDownSection, setDropDownSection] = useState(""); // reserved for dropdown sections
  const [notificationCount, setNotificationCount] = useState(0); // unread count shown on the bell
  const [readMore, setReadMore] = useState(null); // controls "read more" pagination in the dropdown

  // Sync initial value (server-provided) into local state. useMemo is used
  // here to react to changes in `initialValue?.data` and avoid extra renders.
  useMemo(() => {
    setNotificationCount(initialValue?.data);
  }, [initialValue?.data]);

  // Listen for websocket updates. When a websocket message with a
  // notification_count arrives, update the displayed count.
  useEffect(() => {
    if (ws) {
      const { message } = ws;
      if (message?.id && message?.notification_count >= 0) {
        // Use functional update to avoid stale state during rapid updates
        setNotificationCount(() => message.notification_count);
      }
    }
  }, [ws]);

  return (
    <QIDropdown
      // Reset dropdown section when the dropdown hides
      onHide={() => setDropDownSection("")}
      className="user-action-dropdown notification-dropdown "
      // `toggleComponent` is the clickable bell icon that toggles the menu
      toggleComponent={
        <div onClick={() => setReadMore(10)} className="notification">
          <SvgIcon name="bell" />
          {/* Show the red alert badge only when there are unread notifications */}
          {notificationCount > 0 && <span className="notification_alert">{notificationCount}</span>}
        </div>
      }
    >
      {
        // Render the passed-in notification component and forward
        // notification state and controls so it can render list, pagination, etc.
        <OnNotification
          notificationCount={notificationCount}
          readMore={readMore}
          setReadMore={setReadMore}
        />
      }
    </QIDropdown>
  );
};
